import React, { useState } from "react";
import {  Modal, FloatButton, Button} from "antd";
import { TbUsersGroup } from "react-icons/tb";
import ClinicStaff from "../../pages/Dashboard/AdminDashboard/components/ClinicStaff";

const StaffAvailabilityButton = () => {
  const [isStaffModalVisible, setIsStaffModalVisible] = useState(false);

  const showStaffModal = () => {
    setIsStaffModalVisible(true);
  };

  const handleStaffModalCancel = () => {
    setIsStaffModalVisible(false);
  };

  return (
    <>
      {/* Floating Button */}
     <FloatButton
     icon={<TbUsersGroup />}
     tooltip="Staff Availability"
     onClick={showStaffModal}
     type="primary" 
     style={
      {
        right: 24,
        bottom: 24,
      }
     }
     />

      {/* Staff Availability Modal */}
      <Modal
        title="Staff Availability"
        open={isStaffModalVisible}
        onCancel={handleStaffModalCancel}
        footer={null}
        width={1000}
        style={{ top: 20 }}
        closeIcon={
          <Button size="small" className="app-close-icon" shape="round">
            Close
          </Button>
        }
      >
        <ClinicStaff />
      </Modal>
    </>
  );
};

export default StaffAvailabilityButton;
